<div style="width: 600px; height: 340px;" data-cy="imaging-scansetup-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="imaging-scansetup-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="imaging-scansetup-header">
      <div class="section-header-title" data-cy="imaging-scansetup-title">
        TDOx Service Broker Setup
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; text-align: center;" data-cy="imaging-scansetup-content">
      <div style="display: flex;" data-cy="imaging-scansetup-message-container">
        <mat-icon style="color: orange; margin-right: 6px;" data-cy="imaging-scansetup-warning-icon">warning</mat-icon>
        <div style="flex: 1; text-align: left;" [innerHTML]="message" data-cy="imaging-scansetup-message">
        </div>
      </div>
      <div *ngIf="isWindowsEnvironment" data-cy="imaging-scansetup-download-section">
        <br />
        <a target="_self" href="../../assets/leadtools/TDOx.ServiceBroker.Setup.msi" download="TDOx.ServiceBroker.Setup.msi" data-cy="imaging-scansetup-download-link">Download TDOx Service Broker</a>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="imaging-scansetup-footer">
      <div style="flex: 1; margin-right: 6px;"></div>
<!--      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;">Cancel</button>-->
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="imaging-scansetup-ok-button">Ok</button>
    </div>
  </div>
</div>
